module.exports = __webpack_public_path__ + "static/media/Female-Icon-Unselected.de32dce2.svg";